import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
// import FavoriteIcon from '@material-ui/icons/Favorite';

import React, { useState, useEffect } from 'react';

const MESSAGES = [
  {
    text: '$150 OFF con el código: ',
    code: 'HOLAGLOSET',
    suffix: ' ✨',
    link: 'https://gloset.mx/s?hotlist=true',
    hasCopyableCode: true
  },
  {
    text: 'Da like a tus favoritos, recibe ofertas 🚨',
    link: 'https://gloset.mx/my-favorites',
    hasCopyableCode: false
  }
];

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    textAlign: 'center',
    color: '#000000',
    background: '#FFD4DD',
    fontFamily: 'CircularStd, Kenac, Arial, sans-serif !important',
    fontSize: '16px',
    minHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 0',
    cursor: 'pointer',
    transition: 'opacity 0.3s ease',
    '&:hover': {
      opacity: 0.9,
    }
  },
  link: {
    textDecoration: 'none !important',
    color: 'inherit !important',
    width: '100%',
    display: 'block',
    '&:hover': {
      textDecoration: 'none !important',
      color: 'inherit !important',
    },
    '&:visited': {
      color: 'inherit !important',
    },
    '&:active': {
      color: 'inherit !important',
    }
  },
  copyableCode: {
    fontWeight: 'bold',
    textDecoration: 'underline',
    cursor: 'pointer',
    padding: '2px 4px',
    borderRadius: '4px',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
    }
  },
  icon: {
    verticalAlign: 'middle',
    marginLeft: '4px',
    fontSize: '20px'
  }
}));

const ShippingBanner = () => {
  const classes = useStyles();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [copyFeedback, setCopyFeedback] = useState('');

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % MESSAGES.length);
    }, 7000);

    return () => clearInterval(timer);
  }, []);

  const handleCopyCode = async (e, code) => {
    e.preventDefault();
    e.stopPropagation();
    
    try {
      await navigator.clipboard.writeText(code);
      // setCopyFeedback('¡Código copiado!');
      setTimeout(() => setCopyFeedback(''), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
      // setCopyFeedback('Error al copiar');
      setTimeout(() => setCopyFeedback(''), 2000);
    }
  };

  const currentMessage = MESSAGES[currentIndex];

  const renderMessage = () => {
    if (currentMessage.hasCopyableCode) {
      return (
        <>
          {currentMessage.text}
          <span 
            className={classes.copyableCode}
            onClick={(e) => handleCopyCode(e, currentMessage.code)}
            title="Haz clic para copiar el código"
          >
            {currentMessage.code}
          </span>
          {currentMessage.suffix}
          {copyFeedback && <span style={{ marginLeft: '10px', fontSize: '14px' }}>({copyFeedback})</span>}
        </>
      );
    }
    return currentMessage.text;
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <a href={currentMessage.link} className={classes.link}>
            <Paper className={classes.paper}> 
              {renderMessage()}
            </Paper> 
          </a>
        </Grid>
      </Grid>
    </div>
  );
};

export default ShippingBanner;
